import React from 'react';
import { makeStyles, Typography } from 'vendor/material';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: theme.spacing(2),
  },
  label: {
    color: theme.palette.NEUTRAL400,
    fontSize: '0.875rem',
    marginBottom: theme.spacing(1),
  },
  requiredIndicator: {
    color: theme.palette.RED400,
  },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '1rem',
    border: `1px solid ${theme.palette.NEUTRAL200}`,
    borderRadius: '4px',
    backgroundColor: '#F5F5F5 !important',
    color: theme.palette.NEUTRAL900,
    appearance: 'none',
    WebkitAppearance: 'none',
    MozAppearance: 'none',
    '&:focus': {
      outline: 'none',
      borderColor: theme.palette.BLUE400,
      backgroundColor: '#F5F5F5 !important',
    },
    '&:disabled': {
      backgroundColor: theme.palette.NEUTRAL100,
      cursor: 'not-allowed',
      color: theme.palette.NEUTRAL400,
    },
  },
  error: {
    border: `1px solid ${theme.palette.RED400}`,
    '&:focus': {
      borderColor: theme.palette.RED400,
    },
  },
  errorText: {
    color: theme.palette.RED400,
    fontSize: '0.75rem',
    marginTop: theme.spacing(0.5),
  },
}));

interface NoTogglePasswordFieldProps {
  id: string;
  name: string;
  label?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  error?: string | boolean;
  required?: boolean;
  placeholder?: string;
  className?: string;
}

const NoTogglePasswordField: React.FC<NoTogglePasswordFieldProps> = ({
  id,
  name,
  label,
  value,
  onChange,
  onBlur,
  disabled = false,
  error,
  required = false,
  placeholder,
  className,
  ...props
}) => {
  const classes = useStyles();

  return (
    <div className={`${classes.container} ${className || ''}`}>
      {label && (
        <Typography
          variant="body2"
          className={classes.label}
          component="label"
          htmlFor={id}
        >
          {label}
          {required && <span className={classes.requiredIndicator}> *</span>}
        </Typography>
      )}
      <input
        id={id}
        name={name}
        type="password"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        className={`${classes.input} ${error ? classes.error : ''}`}
        autoComplete="new-password"
        style={{ backgroundColor: '#F5F5F5' }}
        {...props}
      />
      {error && typeof error === 'string' && (
        <Typography className={classes.errorText}>{error}</Typography>
      )}
    </div>
  );
};

export default NoTogglePasswordField;
